module.exports = __webpack_public_path__ + "static/media/22ESCWA9.561bb139.jpg";